import { useContext } from 'react';

import { AbTastyContext } from '@/contexts/ab-tasty-context';
import { type AbTastyCampaign, getAbTastyCampaigns } from '@/lib/ab-tasty';

export const useAbTastyTests = (): AbTastyCampaign[] => {
  const abTastyTests = useContext(AbTastyContext);
  return getAbTastyCampaigns(abTastyTests);
};
